<template>
    <!--评委要求澄清与答复记录-->
    <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
            <span>{{title}}</span>
        </div>
        <template>
            <div v-for="(item,index) in tableDataCopy" :key="item.id" class="dataWrapper" v-loading="dataListLoading">
                <div class="iconToolbar-left">
                    {{indexMethod(index)}}
                </div>
                <el-form label-width="150px" class="form viewFormWrapper" style="margin-bottom: 10px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="投标单位：">
                                <span >{{item.applyName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="澄清要求发出时间：" >
                                <span >{{item.sendTime }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="答复截止时间：" >
                                <span >{{item.replyEndtime }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="投标人答复内容：" >
                                <el-input
                                        type="textarea"
                                        disabled
                                        :autosize="{ minRows: 2, maxRows: 6}"
                                        placeholder="请输入内容"
                                        v-model="item.replyContent">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="答复时间：" >
                                <span >{{item.replyTime }}</span>
                            </el-form-item>
                        </el-col>
<!--                            <el-col :span="24">-->
<!--                                <el-form-item label="问题澄清通知：" >-->
<!--                                    <span class="activeColor link" v-if="item.filePath1 != ''" @click="fileDownLoad(item.filePath1,item.fileName1)">{{item.fileName1}}</span>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
<!--                            <el-col :span="24">-->
<!--                                <el-form-item label="投标人澄清答复：" >-->
<!--                                    <span class="activeColor link" v-if="item.filePath2 != ''" @click="fileDownLoad(item.filePath2,item.fileName2)">{{item.fileName2}}</span>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
                    </el-row>
                </el-form>
                <div class="affixDown" v-if="(item.attachments && item.attachments.length > 0)" style="margin-bottom: 10px">
                    <affix-doc v-for="(item,index) in item.attachments"
                               labelWidth="150px"
                               :item.sync="item"
                               :index="index"
                               :key="index"
                               :name="item.titleName"></affix-doc>
                </div>
            </div>
            <p style="text-align: center" v-if="tableData.length == 0">暂无记录数据</p>
            <el-pagination background
                           layout="sizes, prev, pager, next"
                           :page-sizes="[pageSize, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           :current-page="pageIndex"
                           @size-change="sizeChangeHandle"
                           @current-change="currentChangeHandle"></el-pagination>

        </template>
    </el-card>

</template>

<script>
    import affixDoc from '@/components/affixDoc';
    import $ from "jquery";

    export default {
        components: {
            affixDoc
        },
        props:{
            nodeCode:{
                type:String,
                defalut:'GC00014'
            },
            title:{
                type:String,
                defalut:''
            },
            total:{
                type:Number,
                defalut:0
            },
            tableData:{
                type:Array,
                default:()=>([])
            },
            dataListLoading:{
                type:Boolean,
                defalut:false
            },

        },
        watch:{
            nodeCode:{
                immediate: true,
                handler (val) {
                    this.nodeCodeCopy = val
                },
                deep: true
            },
            tableData: {
                immediate: true,
                handler (val) {
                    this.tableDataCopy = this.tableData.map((item, index) => {
                        let itemTemp = JSON.parse(JSON.stringify(item))
                        let attachmentTemp = [];
                        for(var key in itemTemp.fileTypeMap){
                            let obj = JSON.parse(JSON.stringify(itemTemp.fileTypeMap[key]))
                            obj.titleName = key;
                            attachmentTemp.push(obj);
                        }
                        if(itemTemp.attachments.length > 0){
                            itemTemp.attachments.forEach((itemTemp)=>{
                                let index = attachmentTemp.findIndex((val) => val.fileType == itemTemp.fileType);
                                if(index > 0){
                                    attachmentTemp[index] =  {...itemTemp};
                                }
                            })
                        }
                        itemTemp.attachments = attachmentTemp;
                        return itemTemp
                    })

                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },
        },
        data() {
            return {
                pageSize:10,//每页条数
                pageIndex:1,//当前页
                tableDataCopy:[],
                nodeCodeCopy:"",
            }
        },
        activated() {

        },
        methods: {
            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            fileDownload(filePath, fileName) {
                if (filePath) {
                    var a = document.createElement('a');
                    a.download = fileName;
                    a.target = "_Blank";
                    a.href = filePath;
                    $("body").append(a);
                    a.click();
                    $(a).remove();
                }
            },
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageSize})
            },
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageSize})
            },
        }







    }
</script>

<style lang="less" scoped>

    .dataWrapper{
        position: relative;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 10px;
        &:last-child{
            border-bottom: none;
        }
        .iconToolbar-left{
            font-weight: bold;
            color: #fff;
            text-align: center;
            padding-top: 3px;
            position: absolute;
            top: 10px;
            left: 0px;
            width: 32px;
            height: 32px;
            background:url("../../assets/img/bookmark.png")no-repeat;
        }
    }
    .dataWrapper:last-child{
        border-bottom: none;
    }

</style>
